export default "__VITE_ASSET__BpbVy2pQ__"